import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";

const StyledBadgeNormal = styled(Badge, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: active ? "#bfbfbf" : "#f44336",
    color: active ? "#bfbfbf" : "#f44336",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: "1px solid currentColor",
      content: '""',
    },
  },
}));
export default StyledBadgeNormal;
